import {api ,XmartlabApi  }from './api';
import ErrorService from './errorService';



export const estadoCivilService = {

  getEstadoCivil: async () => {
        try {
          const response = await ErrorService.withTimeout(api.get(`/EstadoCivil`));
          return response.data;      
        } catch (error) {
          ErrorService.handleApiError('Error al obtener Estado Civil:', error);
          throw error;
        }
      },

  validacionMatrimonio: async (rut) => {
        try {
          const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxaWQiOiIyOTg5NDg3OC05MjM5LTExZWMtYjkwOS0wMjQyYWMxMjAxMTEiLCJ1c2VyX25hbWUiOiJBc3R1cl9NYXRyaSJ9.wVSe4fCUYSW7q8LCc1EGqP8k6rGcj35hfINrOzG8Q-E';
          const response = await XmartlabApi.post('/validacion_matrimonio', {
            token,
            rut,
          });
    
          return response.data;
        } catch (error) {
          console.error('Error al obtener validación de matrimonio:', error);
          throw error;
        }
      },
      


};